export default __webpack_public_path__ + "static/media/oi_3.fc89c938.mp3";